<!--
  * @Author: w9013327 v-maijiahua@oppo.com
  * @Date: 2022-11-17 10:48:37
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-08-23 16:54:22
  * @FilePath: \sns-user-frontend\src\components\pollTag.vue
  * @Description: 投标标识
 -->
 <template>
  <span class="activity-tag" :class="domClass" ref="tagSpan">{{ $t(domFakeClassContent) }}</span>
</template>

<script setup>
import { ref, watchEffect } from 'vue';
const props = defineProps({
  type: {
    type: Number, // 1 抽奖，2 报名活动，3 已结束
    default: 1
  }
})



const domFakeClassContent = ref('')
const domClass = ref('')
const tagSpan = ref(null)

watchEffect(() => {
  switch (props.type) {
    case 0:
      domFakeClassContent.value = 'poll'
      domClass.value = ''
      break
    case 1:
      domFakeClassContent.value = 'prizeDraw'
      domClass.value = 'prize-draw'
      break
    case 2:
      domFakeClassContent.value = 'application'
      domClass.value = 'application'
      break
    case 3:
      domFakeClassContent.value = 'ended'
      domClass.value = 'ended'
      break
    default:
  }
})

defineExpose({tagSpan})
</script>

<style lang="postcss" scoped>
.activity-tag {
  font-size: 12px;
  padding: 2px 4px;
  color: #fff;
  border-radius: 3px;
  margin-right: 6px;
  background: #0575FA;
}
.prize-draw,.application {
  background: #FF7700;
}
.ended {
  background: #EBEBEB;
  color: rgba(0, 0, 0, 0.55);
}
</style>